import { Integration_Names_Enum } from '@main/graphql/types.generated';

import { ConfigSharepoint } from '../integration-handler-config/config-sharepoint';
import { ConfigurableIntegrationCard } from './configurable-integration-card';
import { ReadonlyIntegrationCard } from './readonly-integration-card';

export type EvidenceIntegrationCardProps = {
  orgIntegrationId: string;
  providerName: Integration_Names_Enum;
  connectorName?: string;
  evidenceConfig?: unknown;
  isDisabled: boolean;
  isReadOnly: boolean;
  isConfigurable: boolean;
  onConfigChange: (payload: Record<string, unknown>) => void;
  onDelete: () => void;
};

export const EvidenceIntegrationCard = ({
  orgIntegrationId,
  providerName,
  connectorName,
  evidenceConfig,
  isDisabled,
  isReadOnly,
  isConfigurable,
  onConfigChange,
  onDelete,
}: EvidenceIntegrationCardProps) => {
  const ConfigComponent = getConfigComponent(providerName);
  if (ConfigComponent && !isReadOnly) {
    return (
      <ConfigurableIntegrationCard
        orgIntegrationId={orgIntegrationId}
        providerName={providerName}
        connectorName={connectorName}
        isDisabled={isDisabled}
        isConfigurable={isConfigurable}
        evidenceConfig={evidenceConfig}
        onConfigChange={onConfigChange}
        onDelete={onDelete}
        ConfigComponent={ConfigComponent}
      />
    );
  }

  return (
    <ReadonlyIntegrationCard
      providerName={providerName}
      connectorName={connectorName}
      isDisabled={isDisabled}
    />
  );
};

function getConfigComponent(name: Integration_Names_Enum) {
  switch (name) {
    case Integration_Names_Enum.Sharepoint:
      return ConfigSharepoint;
    default:
      return null;
  }
}
